import { Component, computed, Input, ChangeDetectionStrategy } from '@angular/core';

import { MediaSliderComponent } from '@sirius/common';
import { VideoContent, VideoItem } from 'matchmaking/models';

@Component({
    selector: 'matchmaking-videos',
    imports: [MediaSliderComponent],
    templateUrl: './videos.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './videos.component.scss'
})
export class VideosComponent {
    @Input() videos!: VideoContent[];

    cardItems = computed(() => {
        if (!this.videos?.length) {
            return [];
        }

        const items: VideoItem[] = [];

        this.videos.forEach((story: VideoContent) => {
            story.media?.forEach((video) => {
                if (!items.some((item) => item.url === video.url)) {
                    items.push(video);
                }
            });
        });

        return items;
    });
}
